<template>
    <q-card class="q-pa-sm" bordered flat>
        <q-card-section horizontal>
            <div class="full-width">
                <div class="text-h6 q-mb-xs">{{ facility }} - {{ type }}</div>
                <div>
                    <q-separator class="q-mb-sm"></q-separator>
                    <div class="row">
                        <div class="text-uppercase report-card__subtitle">
                            <q-icon
                                name="far fa-conveyor-belt"
                                class="q-mr-sm"
                                size="xs"
                            />
                            {{ assetNames }}
                        </div>
                    </div>
                    <div class="row">
                        <div
                            class="q-pt-sm text-uppercase report-card__subtitle"
                        >
                            <q-icon
                                name="fa-solid fa-repeat"
                                class="q-mr-sm"
                                size="xs"
                            />
                            {{ frequency }}
                        </div>
                    </div>
                    <div class="row">
                        <div
                            class="q-pt-sm text-uppercase report-card__subtitle"
                        >
                            <q-icon
                                name="fa-regular fa-file-spreadsheet"
                                class="q-mr-sm"
                                size="xs"
                            />
                            {{ getReportPeriod }}
                        </div>
                    </div>
                    <div class="row">
                        <div
                            class="q-pt-sm text-uppercase report-card__subtitle"
                        >
                            <q-icon
                                name="far fa-clock"
                                class="q-mr-sm"
                                size="xs"
                            />
                            {{ time }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Actions -->
            <q-separator vertical></q-separator>
            <q-card-actions
                class="col-auto justify-around q-pl-xs q-pr-none"
                align="right"
                vertical
            >
                <q-card-actions
                    class="col-auto justify-around q-pl-xs q-pr-none"
                    align="right"
                    vertical
                >
                    <q-separator vertical></q-separator>
                    <q-btn
                        @click="$emit('edit')"
                        class="q-pa-sm card__button--edit"
                        icon="fas fa-edit"
                        color="accent"
                        size="md"
                        flat
                    />
                    <q-btn
                        @click="$emit('delete')"
                        color="red-6"
                        class="q-pa-sm card__button--delete"
                        icon="fas fa-trash"
                        size="md"
                        flat
                    />
                </q-card-actions>
            </q-card-actions>
        </q-card-section>
    </q-card>
</template>

<script>
import { mapState } from 'pinia';
import { useAssetsStore } from '@stores/assets.ts';
import { useFacilitiesStore } from '@stores/facilities.ts';
import { getAutomaticReportsPeriodLabel } from '@utils/automaticReportsUtils.js';

export default {
    name: 'AutomaticReportCard',
    props: {
        facility: {
            type: String,
            required: true
        },
        assets: {
            type: Array,
            required: false
        },
        type: {
            type: String,
            required: true
        },
        frequency: {
            type: String,
            required: true
        },
        time: {
            type: String,
            required: true
        },
        dateRangeWindow: {
            type: Number,
            required: true
        },
        dateRangeUnit: {
            type: String,
            required: true
        }
    },
    methods: {
        getAutomaticReportsPeriodLabel
    },
    computed: {
        ...mapState(useFacilitiesStore, ['getFacility']),
        ...mapState(useAssetsStore, ['getAsset']),
        assetNames() {
            if (this.assets && this.assets.length === 0) {
                return this.$t('All Assets');
            }

            return this.assets
                .map(assetId => this.getAsset(assetId)?.name)
                .join(', ');
        },
        getReportPeriod() {
            if (this.dateRangeWindow && this.dateRangeUnit) {
                return this.getAutomaticReportsPeriodLabel(
                    this.dateRangeWindow,
                    this.dateRangeUnit
                );
            }
            return '-';
        }
    }
};
</script>

<style lang="scss">
.report-card__subtitle {
    color: $grey-8;
}

.report-card__description {
    color: $grey-7;
}

.report-card--selectable {
    cursor: pointer;
}

.report-card--selected {
    background-color: $grey-3;
}

.target-downtime {
    display: inline-block;
}
</style>
